export const routeName = 'TableTimeAndLoadPage'

export const route = {
  path: '/load-calendar/table-time-and-load/:id?',
  name: routeName,
  component: () => import('./TableTimeAndLoadPage.vue')
}
